import { render } from "./StudyGeneralSettings.vue?vue&type=template&id=767a3a8c&scoped=true"
import script from "./StudyGeneralSettings.vue?vue&type=script&lang=js"
export * from "./StudyGeneralSettings.vue?vue&type=script&lang=js"

import "./StudyGeneralSettings.vue?vue&type=style&index=0&id=767a3a8c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767a3a8c"]])

export default __exports__